/* Tres Vera — analytics + consent gate.

   Wires Klaviyo onsite tracking (`_learnq`) and gates every dispatch
   behind Shopify's Customer Privacy API so EU visitors are honoured.

   Subscribes to:
     - cart:added         → Klaviyo "Added to Cart"
     - cart:updated       → updates Klaviyo cart total
     - DOMContentLoaded   → fires "Viewed Product" on PDP

   Reads window.tvAnalyticsCfg set inline from layout/theme.liquid:
     { klaviyo_enabled, klaviyo_public_key, klaviyo_payload_*  } */
(function () {
  const cfg = window.tvAnalyticsCfg || {};

  function canTrack() {
    try {
      if (!window.Shopify || !window.Shopify.customerPrivacy) return true;
      return window.Shopify.customerPrivacy.userCanBeTracked();
    } catch (e) { return false; }
  }

  function loadKlaviyo() {
    if (!cfg.klaviyo_enabled || !cfg.klaviyo_public_key) return;
    if (window._learnq && window._learnq.account) return;
    window._learnq = window._learnq || [];
    window._learnq.push(['account', cfg.klaviyo_public_key]);
    if (!document.querySelector('script[src*="static.klaviyo.com/onsite"]')) {
      const s = document.createElement('script');
      s.async = true;
      s.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(cfg.klaviyo_public_key);
      document.head.appendChild(s);
    }
  }

  function track(eventName, payload) {
    if (!canTrack()) return;
    loadKlaviyo();
    if (window._learnq) window._learnq.push(['track', eventName, payload || {}]);
  }

  // PDP — Viewed Product
  document.addEventListener('DOMContentLoaded', () => {
    if (cfg.viewed_product) track('Viewed Product', cfg.viewed_product);
  });

  // Cart events from tv-cart.js
  document.addEventListener('cart:added', (e) => {
    const item = e.detail || {};
    track('Added to Cart', {
      $value: (item.final_line_price || 0) / 100,
      AddedItemProductName: item.product_title,
      AddedItemSKU: item.sku,
      AddedItemQuantity: item.quantity,
      AddedItemURL: item.url,
      ItemNames: [item.product_title],
    });
  });

  document.addEventListener('cart:updated', (e) => {
    const cart = e.detail || {};
    track('Updated Cart', {
      $value: (cart.total_price || 0) / 100,
      ItemNames: (cart.items || []).map((i) => i.product_title),
      Items: (cart.items || []).map((i) => ({
        ProductName: i.product_title,
        Quantity: i.quantity,
        ItemPrice: (i.price || 0) / 100,
        RowTotal: (i.line_price || 0) / 100,
      })),
    });
  });
})();
